import { createRouter, createWebHistory } from 'vue-router'
import configuration from '@/provider/configuration.js'


class RouterProvider {
  constructor() {
    this.router = null
    return new Proxy(this, {
      get(target, prop) {
        // Se la proprietà non esiste nella classe, la cerchiamo nel router
        if (prop in target) {
          return target[prop];
        } else if (target.router !== null && prop in target.router) {
          return target.router[prop];
        } else {
          return undefined; // o puoi lanciare un errore se necessario
        }
      },
      set(target, prop, value) {
        // Se la proprietà non esiste nella classe, la settiamo nel router
        if (target.router !== null && prop in target.router) {
          target.router[prop] = value;
          return true;
        } else {
          target[prop] = value;
          return true;
        }
      }
    });
  }

  getRouter() {
    return this.router
  }

  getRoutes() {
    if (this.router) {
      return this.router.getRoutes()
    }
    return []
  }

  initialize() {
    let appRoutes = []
    const config = configuration.getConfig()
    if (config.routes) {
      config.routes.forEach((route) => {
        let currRoute = {
          path: route.path || `/${route.name}`,
          name: `${route.name}`,
          meta: { sidebar: route.meta.sidebar || true, ...route.meta },
          props: route.props || false,
        }

        if (route.folder) {
          currRoute.component = () => import(`@/components/${route.folder}/${route.component}.vue`)
          currRoute.meta = { ...currRoute.meta, folder: route.folder }
        } else {
          currRoute.component = () => import(`@/components/${route.component}.vue`)
        }

        appRoutes.push(currRoute)

        if (route.type === 'crud') {
          appRoutes.push({
            path: `/${route.name}/:id/show`,
            name: `${route.name}--detail`,
            component: () => import(`@/components/${route.folder}/${route.component}Detail.vue`),
            meta: { ...route.meta, folder: route.folder },
          })
          appRoutes.push({
            path: `/${route.name}/new`,
            name: `${route.name}--new`,
            component: () => import(`@/components/${route.folder}/${route.component}New.vue`),
            meta: { ...route.meta, folder: route.folder },
          })
          appRoutes.push({
            path: `/${route.name}/:id/edit`,
            name: `${route.name}--edit`,
            component: () => import(`@/components/${route.folder}/${route.component}Edit.vue`),
            meta: { ...route.meta, folder: route.folder },
          })
        }
      })
    }

    this.router = createRouter({
      history: createWebHistory(config.baseUrl),
      routes: appRoutes
    })
  }

}
let instance = null;
function getInstance() {
  if (!instance) {
    instance = new RouterProvider()
  }
  return instance
}

export default getInstance()
